import mentionPlugin from 'draft-js-mention-plugin';
import createLinkifyPlugin from 'draft-js-linkify-plugin';
import toolbarPlugin from 'draft-js-static-toolbar-plugin';

import { IMentionPluginArgs, IToolbarPluginArgs } from './types';
import createLinkPlugin from './Plugins/Link/linkPlugin';

const linkPlugin = createLinkPlugin();
const linkifyPlugin = createLinkifyPlugin();
const createMentionPlugin = ({ theme }: IMentionPluginArgs) => mentionPlugin({ theme });
const createToolbarPlugin = ({ theme }: IToolbarPluginArgs) => toolbarPlugin({ theme });

export { linkPlugin, linkifyPlugin, createMentionPlugin, createToolbarPlugin };
